const pathsManifest = {
  FrontPage: '/',

  PriceMyRentalPage: '/rental-manager/price-my-rental',
  PriceMyRentalPageResults: '/rental-manager/price-my-rental/results',
  MarketTrendsPage: '/rental-manager/market-trends',
  UnsubscribePage: '/rental-manager/growth/unsubscribe/marketUpdate',
  UnsubscribeAllPage: '/rental-manager/growth/unsubscribe/marketUpdateAll',

  ZRMLoginPage: '/rental-manager/login',
};

export default pathsManifest;
